import {
    ApiParams,
    BaseClient,
    IActionResponse,
    IActionResult,
    IPagedResult,
} from "../../../assets/utils/lib";
import { ViewProps } from "../../../components/herenow/banner/props";
import { BannerDto, BannersGridDto, LookupDto, SearchBannerDto } from "../../dto";

export class BannerClient extends BaseClient {
    routes = ["pophub", "Banner"];
    async getBannerAsync(bannerId: string | undefined): Promise<BannerDto> {
        const actions: string[] = ["GetBanner"];
        const params: ApiParams[] = [new ApiParams("bannerId", bannerId, true)];
        const result: BannerDto = await this.getAsync<BannerDto>(actions, params);
        return result;
    }

    async searchBannerAsync(communityId: string | null | undefined, payload: SearchBannerDto | undefined): Promise<IPagedResult<BannersGridDto>> {
        const actions: string[] = ["{communityId}", "SearchBanner"];
        const result: IPagedResult<BannersGridDto> = await this.postAsync<SearchBannerDto, BannersGridDto, IPagedResult<BannersGridDto>>(actions, payload, { communityId: communityId });
        return result;
    }

    async getBannerLookupsAsync(communityId: string | undefined): Promise<ViewProps.BannerTypeLookupProps> {
        const bannerTypeActions: string[] = ["{communityId}", "Lookups", "BannerType"];
        const routeParams = { communityId };
        const bannerType = await this.getAsync<LookupDto[]>(bannerTypeActions, undefined, routeParams);

        return {
            bannerType,
        };
    }

    async getBannerLocationLookupsAsync(communityId: string | undefined): Promise<LookupDto[]> {
        const actions: string[] = ["{communityId}", "Lookups", "BannerLocation"];
        return await this.getAsync<LookupDto[]>(actions, undefined, { communityId });
    }

    async saveBannerAsync(payload: BannerDto | undefined): Promise<IActionResult<BannerDto>> {
        const actions: string[] = ["SaveBanner"];
        return await this.postAsync<BannerDto>(actions, payload);
    }

    async deleteBannerAsync(bannerId: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeleteBanner"];
        const params: ApiParams[] = [new ApiParams("bannerId", bannerId, true)];
        return await this.deleteAsync(actions, params);
    }
}
